import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { useSelector } from 'react-redux';
import AppButton from '../../../common_components/AppButton';
import CommonDrawerLayout from '../../../common_components/CommonDrawerLayout';
import { Dropdown } from '../../../common_components/FormInputs';
import { toast } from '../../../common_components/Toast/ToastUtils';
import { selectScorerClients, selectScorerOptionsLoading } from '../../../redux/meetingScorerSlice';
import { apiErrorMessage } from '../../../redux/meetingAgendaSlice';
import meetingScorerService from '../../../services/meetingScorer.service';
const LinkClientDrawer = ({ open, meeting, onClose, onSaved }) => {
    const clients = useSelector(selectScorerClients);
    const optionsLoading = useSelector(selectScorerOptionsLoading);
    const token = useSelector((state) => state.auth.token);
    const [clientId, setClientId] = useState('');
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        if (!open)
            return;
        setClientId('');
        setError('');
    }, [open, meeting]);
    const clientOptions = useMemo(() => clients.map((c) => ({ value: c.id, label: c.name })), [clients]);
    const handleSave = async () => {
        if (!meeting)
            return;
        if (!clientId) {
            setError('Choose a client.');
            return;
        }
        setSaving(true);
        try {
            const res = await meetingScorerService.linkClient(meeting.id, clientId, token || '');
            if (res?.data?.success) {
                toast.success(res.data.message || 'Client linked.');
                onSaved();
                onClose();
            }
            else {
                const fieldError = res?.data?.data?.errors?.find?.((e) => e.field === 'client_id');
                if (fieldError)
                    setError(fieldError.message);
                toast.error(apiErrorMessage(res, 'Could not link the client.'));
            }
        }
        catch {
            toast.error('Could not link the client.');
        }
        finally {
            setSaving(false);
        }
    };
    return (_jsx(CommonDrawerLayout, { open: open, onClose: onClose, title: "Link to Client", isLoading: saving, width: "sm", headerActions: _jsx(AppButton, { variant: "contained", size: "small", onClick: handleSave, disabled: saving, startIcon: _jsx(SaveOutlinedIcon, { sx: { fontSize: 18 } }), sx: { textTransform: 'none', borderRadius: '999px', px: 2.5, fontSize: 13, fontWeight: 600, bgcolor: '#FF008E', '&:hover': { bgcolor: '#e0007c' } }, children: "Save" }), children: _jsxs(Box, { sx: { px: 1, py: 1, display: 'flex', flexDirection: 'column', gap: 1.5 }, children: [_jsxs(Typography, { sx: { fontSize: 12, color: '#667085' }, children: ["\"", meeting?.client_name, "\" was typed in because it was not in the portal. Pick the client it now matches. Only the client is changed \u2014 the meeting is not scored again; regenerate the report if you want it scored with this client's details and dashboard numbers."] }), _jsxs(Box, { children: [_jsxs(Typography, { sx: { fontSize: 11, color: '#667085', mb: 0.5, fontWeight: 500 }, children: ["Client Name", _jsx(Box, { component: "span", sx: { color: '#EF4444', ml: 0.5 }, children: "*" })] }), _jsx(Dropdown, { value: clientId, onChange: (val) => { setClientId(Array.isArray(val) ? val[0] ?? '' : String(val ?? '')); setError(''); }, options: clientOptions, size: "sm", placeholder: "Select client", fullWidth: true, searchable: true, loading: optionsLoading, usePortal: true, error: !!error, errorMessage: error })] })] }) }));
};
export default LinkClientDrawer;
